import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import axios from 'axios'

import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";

Vue.use(Vuex);

const state = {
    status: '',
    userData: {},
    showSpinner: false,
    newSubscriberSearchParams: {},
    rpReplacementSearchParams: {},

    fileExtensions: ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'tiff', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'zip', 'rar', '7z', 'djvu'],
    maxFileSize: 50 * 1024 * 1024,
    recordCountPerPageArray: [5, 10, 20, 30, 50, 100],
    recordCountPerPage: 20,
}

const getters = {
    isLoggedIn: state => (!!state.userData.Session_UID),
    getUserData: state => state.userData,
    getFileExtensions: state => state.fileExtensions,
    getMaxFileSize: state => state.maxFileSize,
    getRecordCountPerPageArray: state => state.recordCountPerPageArray,
    getRecordCountPerPage: state => state.recordCountPerPage,
    getNewSubscriberSearchParams: state => state.newSubscriberSearchParams,
}

const mutations = {
    auth_request(state) {
        state.status = 'loading'
    },
    auth_success(state, userData) {
        state.status = 'success'
        state.userData = userData
    },
    auth_error(state) {
        state.status = 'error'
    },
    logout(state) {
        if (state.userData.Session_UID) {
            axios.post("/ws/ws.svc/CloseUserSession", {'Session_UID': state.userData.Session_UID},
                {headers: {"Content-Type": "application/json"}}
            )
        }

        state.status = ''
        state.userData = []
        localStorage.removeItem('vuex')
    },
    set(state, [variable, value]) {
        state[variable] = value
    },
    show_spinner(state) {
        state.showSpinner = true
    },
    hide_spinner(state) {
        state.showSpinner = false
    },
}

export default new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.localStorage,
    })],
    state,
    getters,
    mutations,
    modules: {
        htmlClass,
        config,
        breadcrumbs,
    },
    actions: {
        login({commit}, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')

                axios.post("/ws/ws.svc/UserAuthorize", user,
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (typeof resp.data.response !== "undefined" && typeof resp.data.success !== "undefined"
                            && typeof resp.data.UserAccessJson !== "undefined"
                            && typeof resp.data.UserGroup !== "undefined"
                            && typeof resp.data.UserGroup_UID !== "undefined"
                            && typeof resp.data.UserName !== "undefined"
                        ) {
                            let userData = {}
                            let userAccessJson = ""
                            if (typeof resp.data.UserAccessJson !== "undefined" && resp.data.UserAccessJson.length > 0)
                                userAccessJson = JSON.parse(resp.data.UserAccessJson)

                            userData.Session_UID = resp.data.Session_UID.toString()
                            userData.UserLogin = user.Login
                            userData.UserName = resp.data.UserName
                            userData.UserGroup = resp.data.UserGroup
                            userData.UserGroupUid = resp.data.UserGroup_UID
                            userData.UserAccess = userAccessJson.ua

                            userData.UserPhotoUrl = ""
                            if (typeof resp.data.data !== "undefined" && resp.data.data.length > 0) {
                                let d = JSON.parse(resp.data.data)
                                if (typeof d.UserAvatarURL !== "undefined" && typeof d.UserAvatarURL.AttachmentURL !== "undefined") {
                                    userData.UserPhotoUrl = d.UserAvatarURL.AttachmentURL.toString()
                                }
                            }

                            commit('auth_success', userData)
                            resolve(resp)
                        } else {
                            commit('auth_error')
                            reject(resp)
                        }
                    })
                    .catch(err => {
                        commit('auth_error')
                        reject(err)
                    })
            })
        },
        logout({commit}) {
            return new Promise((resolve, reject) => {
                commit('logout')
                resolve()
            })
        },
    }
});
